import {Component, computed, inject, input, linkedSignal, resource, signal, viewChild} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {take} from 'rxjs/operators';
import {DxDataGridComponent, DxDataGridModule, DxNumberBoxModule, DxPopupModule} from 'devextreme-angular';
import {SharedModule} from '../../../../../shared/shared.module';
import {StockMinimum} from '../../../../../core/models/gestion-stock/stock-minimum.model';
import {ProduitDeclinaisonDTO} from '../../../../../core/dtos/produit-declinaison-dto';
import {StockService} from '../../../../../core/services/entities/stock-service';
import {ButtonThemeEnum} from '../../../../../shared/ui/button/button-theme-enum';

@Component({
  selector: 'yo-gestion-stock-minimum-dialog',
  templateUrl: './dialog-gestion-stock-minimum.component.html',
  standalone: true,
  imports: [
    SharedModule,
    DxPopupModule,
    DxNumberBoxModule,
    DxDataGridModule
  ]
})
export class DialogGestionStockMinimumComponent {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  produitDeclinaison = input<ProduitDeclinaisonDTO>();

  private grid = viewChild.required<DxDataGridComponent>('grid');

  stockMinimumAmount = signal<number>(null);

  #stockSvc = inject(StockService);

  #openRequest = toSignal(this.#stockSvc.openDialogGestionStockMini$);

  #stockMinimumResource = resource<StockMinimum[], ProduitDeclinaisonDTO>({
    params: () => this.#openRequest(),
    loader: ({params}) => {
      if (!params) return Promise.resolve([]);
      return this.#stockSvc.getStockMinimumList(this.produitDeclinaison().id)
        .pipe(take(1))
        .toPromise()
        .then(response => response.resultList);
    }
  });

  displayDialog = linkedSignal(() => this.#openRequest() != null);
  stockMinimumList = computed(() => this.#stockMinimumResource.value() ?? []);

  appliquerEnMasse = (): void => {
    const selectedSites = this.grid().instance.getSelectedRowsData().map(item => item.site.id);
    if (selectedSites.length > 0) {
      this.stockMinimumList().filter(stockMinimum => selectedSites.includes(stockMinimum.site.id))
        .forEach(stockMinimum => stockMinimum.amount = this.stockMinimumAmount());
    } else {
      this.stockMinimumList().forEach(stockMinimum => stockMinimum.amount = this.stockMinimumAmount());
    }
    this.grid().instance.clearSelection();
  };

  closeDialog = () => {
    this.displayDialog.set(false);
  };

  save = () => {
    this.#stockSvc.saveStockMinimumList(this.produitDeclinaison().id, this.stockMinimumList())
      .subscribe(res => this.#stockMinimumResource.set(res.resultList));
    this.displayDialog.set(false);
  };
}
